// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"0ade86fd","568":"56d99a19","684":"26b26099","832":"8126411f","953":"16c0989e"}[chunkId] + ".chunk.js";
};